import { render, staticRenderFns } from "./SimpleParagraphs.vue?vue&type=template&id=62bf4a00&"
import script from "./SimpleParagraphs.vue?vue&type=script&lang=js&"
export * from "./SimpleParagraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports